import { message } from 'antd'
import { sendEmailNow } from '../../../HttpRequests/emails'
import { getProps } from '../props'

export default () => async (dispatch) => {

  const { id, onClose } = getProps()

  try {
    await sendEmailNow(id)
    message.success('Email queued to send immediately')
    onClose()
  } catch (err) {
    const errorMsg = err.response && err.response.data && err.response.data.error
      ? err.response.data.error
      : 'Failed to send email'
    message.error(errorMsg)
  }

}
